/* Il Castello — institutional PDP.
   The theme's <product-form> (component-product-form.js) already posts to the
   cart and refreshes the drawer contents; on retail PDPs it is <product-page>
   (section-main-product.js) that then opens the drawer. This element does only
   that last step for the institutional section. */
if (!customElements.get('ilc-institutional-product')) {
  class IlcInstitutionalProduct extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;

      const form = this.querySelector('[data-js-product-form]');
      const settings = window.KROWN && window.KROWN.settings;
      if (!form || !settings || document.body.classList.contains('template-cart')) return;
      if (settings.cart_action !== 'overlay' && settings.cart_action !== 'popup') return;

      const button = form.querySelector('[data-js-product-add-to-cart]');
      let viaKeyboard = false;
      button?.addEventListener('keyup', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          viaKeyboard = true;
          window.lastFocusedElm = button;
        }
      });

      form.addEventListener('add-to-cart', () => {
        const sidebar = document.getElementById('site-cart-sidebar');
        if (sidebar && typeof sidebar.show === 'function') sidebar.show();
        const recommendations = document.getElementById('cart-recommendations');
        if (recommendations && typeof recommendations.generateRecommendations === 'function') {
          recommendations.generateRecommendations();
        }
        if (viaKeyboard) {
          window.setTimeout(() => {
            document.querySelector('#site-cart-sidebar [data-js-close]')?.focus();
            viaKeyboard = false;
          }, 200);
        }
      });
    }
  }

  customElements.define('ilc-institutional-product', IlcInstitutionalProduct);
}
